import React from 'react';

export default function GlobalInfoAlert(props) {
	// console.log('GlobalErrorsBox', props);

	const { globalInfoAlerts = [] } = props;

	if (globalInfoAlerts && globalInfoAlerts.length) {
		return (
			<div className="GlobalInfoAlert my-3">
				<div>{globalInfoAlerts}</div>
			</div>
		);
	}
	return null;
}
